export default __webpack_public_path__ + "static/media/EU.1ba5dd81.jpg";